import { FC } from 'react';
import { Typography, Paper, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound: FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Paper sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          ۴۰۴ - صفحه مورد نظر یافت نشد
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          متأسفانه صفحه‌ای که به دنبال آن هستید وجود ندارد.
        </Typography>
        <Button variant="contained" onClick={() => navigate('/')}>
          بازگشت به صفحه اصلی
        </Button>
      </Paper>
    </Box>
  );
};

export default NotFound; 